import './MemberCard.css';
import React, {Component} from 'react';
import axios from 'axios';
import MemberStat from './MemberStat';
import config from './../config.json';
import { GlobalSiteContext } from '../context/GlobalSiteContext';

class MemberCard extends Component{

    static contextType = GlobalSiteContext

    constructor() {
        super();
        this.state = { member: null,error: null};
        
    }
    
    componentDidMount() {
        let self = this;
        axios.get(`${config.base_url}/api/member/${this.props.summonerId}`)
          .then(res => {
            let data = res.data;
            this.setState({member: data});
        })
        .catch(function (error) {
            // handle error
            self.setState(prevState => ({
                error: error
            }));
            console.log(error.toString());
        })
        
      }

    render() {
        // AEG Shaunz
        // mistermv
        // DFG DrFeelgood
        // AEG PasDeBol
        // AEG Magarky
        // AEG Un33d
        let placementChallenger = 0;
        let totalChallenger = 0;
        let self = this;
        const {challengerLeague} = this.context;
        
        if(challengerLeague != null){
            totalChallenger = challengerLeague.entries.length
            if(this.state.member != null && this.state.member.tier === "CHALLENGER")
            {
                challengerLeague.entries.forEach(function(e,index){
                    if(e.summonerId === self.state.member.summonerId) {
                        placementChallenger = index;
                        
                        return;
                    }
                })
            }
        }
        
        let letfColumn = <></>
        let rightColumn = <></>
        let myClassName = null;
        if(this.state.member != null){
            if(this.state.member !== "") {
                letfColumn = 
                <div className="p-2 flex flex-col justify-start" style={{zIndex: '1'}}>
                    <div><h5 className="text-gray-900 text-xl leading-tight font-bold mb-2 gold-aegis text-left">{this.props.name}</h5></div>
                    <div className='text-left flex flex-col'>
                        <div className='flex bg-gradient-to-r from-slate-300 p-1'>
                            <div className='font-bold basis-1/2'>TOP 1</div>
                            <div className=''>{new Intl.NumberFormat('fr-FR').format(this.state.member.top1)}</div>
                        </div>
                        <div className='flex bg-gradient-to-r from-slate-200 p-1'>
                            <div className='font-bold basis-1/2'>% Top 1</div>
                            <div>{ ((this.state.member.top1 / this.state.member.played) * 100).toFixed(1)} %</div>
                        </div>
                        <div className='flex bg-gradient-to-r from-slate-300 p-1'>
                            <div className='font-bold basis-1/2'>Winrate</div>
                            <div>{ ((this.state.member.top4 / this.state.member.played) * 100).toFixed(1)} %</div>
                        </div>
                        <div className='flex bg-gradient-to-r from-slate-200 p-1'>
                            <div className='font-bold basis-1/2'>Rang moyen</div>
                            <div>{ new Intl.NumberFormat('fr-FR',{ maximumSignificantdigits: 2 }).format(this.state.member.avgRank)}</div>
                        </div>
                        {this.state.member.tier === "CHALLENGER" ? 
                        <div className='flex bg-gradient-to-r from-slate-300 p-1'>
                            <div className='font-bold basis-1/2'>Challenger</div>
                            <div>{placementChallenger+ " / "+totalChallenger}</div>
                        </div>
                        :''}
                    </div>
                </div>
                rightColumn = <div className="p-2 flex flex-col content-end items-end text-center" style={{zIndex: '1'}}>
                        <div>
                            <div style={{textAlign: '-webkit-center'}}>
                                <img className="rounded-r-lg md:rounded-none md:rounded-r-lg" src={require(`./../assets/img/rank/${this.state.member.tier.toLowerCase()}.png`)} alt="" style={{width:'128px'}}/>
                            </div>
                            <div className="flex-nowrap">
                                <span className="font-bold">{this.state.member.tier} {this.state.member.rank}</span>
                                <div className="font-bold league-point">{this.state.member.leaguePoints} LP</div>
                            </div>
                        </div>
                        
                    </div>
                switch (this.props.name) {
                    case "AEG Shaunz":
                        myClassName = 'shaunz-bg';        
                        break;
                    case "AEG mistermv":
                        myClassName = 'mv-bg';
                        break;
                    case "AEG DFG":
                        myClassName = 'dfg-bg';
                        break;
                    case "AEG PasDeBol":
                        myClassName = 'pdb-bg';
                        break;
                    case "AEG Magarky":
                        myClassName = 'magarky-bg';
                        break;
                    case "AEG Un33d":
                        myClassName = 'un33d-bg';
                        break;
                    default:
                        break;
                }
            } else {
                letfColumn = 
                <div className="p-3 flex flex-col justify-start">
                    <h5 className="text-gray-900 text-xl leading-tight font-bold mb-2 drop-shadow gold-aegis text-left">{this.props.name}</h5>
                    <p className="text-gray-700 text-base mb-4">No Data</p>
                </div>
                rightColumn = <></>
            }
            return(
                <div id={"box_"+this.props.name} className={`bg-white grid grid-cols-2 rounded shadow px-0 py-0 justify-between`} style={{ position: 'relative' }}>
                    {letfColumn}
                    {rightColumn}
                    <div className='col-span-2 flex flex-col justify-end' style={{zIndex: 1}} >
                        <MemberStat showAdvancedStat={this.props.showAdvancedStat} played={this.state.member.played} summonerId={this.props.summonerId} name={this.props.name} puuid={this.props.puuid} />
                    </div>
                    <div className={`background-image ${myClassName} opa-2`}></div>                    
                    
                </div>
                
                
            )
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
                    {this.state.error != null ? <div className='text-gray-600'>{this.state.error.toString() === "Error: Network Error" ? "Erreur de récupération de l'api": this.state.error.toString()}</div> : 
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
                    }
				</div>
			)
		}
        
    }
}
export default MemberCard